import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { HcPatientAppointmentHdrContainerModel } from '../../../../../models/aggregates/healthcare/patient_appointment_hdr.model';

@Injectable({ providedIn: 'root' })
export class HcPatientAppointmentHdrBackofficeService extends BaseApiTemplateService<HcPatientAppointmentHdrContainerModel> {
    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + "patient-appointment-hdrs";

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'patient-appointment-hdrs' + '/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'patient-appointment-hdrs' + '/backoffice-ep';
        this.httpClient = http;
    }
}